import React from "react";
import UrlUtils from "core/lib/url-utils";
import { Notice } from "components/common-ui";

type AccountNotFoundProps = {
    display?: boolean,
    onRetry?: any
}

const applicationPath = "/business/{language}/dstv-business-packages/application/";

const applyNow = () => {
    const url = UrlUtils.parseUrl(applicationPath);
    window.location.pathname = UrlUtils.parseUrl(url);
}

const AccountNotFound = (props: AccountNotFoundProps) => {
    const { display = true, onRetry } = props;

    if (display === false) {
        return null;
    }

    return (
        <Notice className="account-not-found">
            <i className="result-icon icon-info"></i>

            <h1>DStv account not found</h1>

            <p>
                We could not find any information with the details provided.
                Please check the information provided or try another option.
            </p>
            <p>
                If you are not an existing DStv Business Customer, click "Apply Now" below to have a
                business consultant contact you and assist you with signing up for DStv Business.
            </p>

            <button className="btn btn-black" onClick={applyNow}>Apply Now</button>

            <button className="anchor try-again" onClick={onRetry}>Try again</button>
        </Notice>
    );
}

export default AccountNotFound;
